/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import ProductsRubix16 from "partsproducts/ProductsRubix16";
import Footer from "parts/Footer";
import Products from "parts/ProductsBlog2.js";
import { RubixIO16, Blog2 } from "../json/ProductsPageData.js";

export default class RubixIOPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Rubix IO-16 | Nube iO – Flexible Smart I/O Module</title>
          <meta
            name="description"
            content="The Rubix IO-16 offers wireless expansion for BMS and HVAC—ideal for fast installations and retrofits."
          />
          <meta
            name="keywords"
            content="wireless I/O module, LoRa I/O, HVAC control"
          />
          <link rel="canonical" href="https://nube-io.com/io-modules/" />
          <meta
            property="og:title"
            content="Rubix IO-16 | Nube iO – Flexible Smart I/O Module"
          />
          <meta
            property="og:description"
            content="The Rubix IO-16 offers wireless expansion for BMS and HVAC—ideal for fast installations and retrofits."
          />
          <meta property="og:url" content="https://nube-io.com/io-modules/" />
        </Helmet>
        <Header1 />
        <ProductsRubix16 data={RubixIO16} />
        <Products data={Blog2} />
        <Footer />
      </>
    );
  }
}
